import { Autocomplete, TextField, Chip } from "@mui/material";

const MultiSelectAutocomplete = ({
  id = "multi-select-autocomplete",
  placeholder = "Select items",
  options = [],
  value = [],
  labelKey = "username",
  disabled = false,
  onChange = () => {},
}) => {
  return (
    <Autocomplete
      multiple
      id={id}
      options={options}
      getOptionLabel={(option) => option[labelKey] || ""}
      value={value}
      onChange={onChange}
      disabled={disabled}
      filterSelectedOptions
      renderTags={(selected, getTagProps) =>
        selected.map((option, index) => (
          <Chip
            key={option.id || option[labelKey]}
            label={option[labelKey]}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} />
      )}
    />
  );
};

export default MultiSelectAutocomplete;
